import React, { useCallback, useState } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button as AntdButton, Modal as AntdModal } from 'antd';

import { useGFFilterContext } from 'hooks/GFFilterStoreContext';

import Creation from '../../../Dossier/Creation';

import './CreateDossier.less';

/**
 * @deprecated Utiliser CreateDossier
 */
function CreateDossierSansJustice(): React.ReactElement {
  const [visible, setVisible] = useState(false);
  const [, setfilters] = useGFFilterContext();

  const handleClosure = useCallback(() => {
    setVisible(false);
    setfilters(filters => {
      return {
        ...filters,
      };
    });
  }, [setVisible, setfilters]);

  return (
    <>
      <AntdButton
        className={'create-dossier-button'}
        icon={<PlusOutlined />}
        type={'primary'}
        shape={'round'}
        onClick={() => setVisible(true)}
      >
        Créer une nouvelle fiche véhicule
      </AntdButton>

      <AntdModal
        title={
          <div className={'centered'}>Créer une nouvelle fiche véhicule</div>
        }
        open={visible}
        onCancel={() => setVisible(false)}
        destroyOnClose={true}
        width={'55%'}
        footer={null}
        maskClosable={false}
      >
        <Creation callAfterSubmit={handleClosure} />
      </AntdModal>
    </>
  );
}

export default CreateDossierSansJustice;
